import { createContext } from 'react';

export const InventoryDependencyContext = createContext(null);
